import React from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import { X } from 'lucide-react';
import { useWebAuth } from '../context/WebAuthContext';

export default function LoginPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { isAuthed } = useWebAuth();
  const requested = params.get('returnTo') || '/account';
  const returnTo = requested.startsWith('/') && !requested.startsWith('//') && !requested.includes('\\') && !requested.startsWith('/login') ? requested : '/account';
  if (isAuthed) return <Navigate to={returnTo} replace />;

  return (
    <main className="relative w-full bg-[#005bbb]" dir="rtl">
      <button type="button" aria-label="بازگشت به سایت" title="بازگشت به سایت" onClick={() => navigate('/')} className="absolute left-4 top-4 z-10 grid h-10 w-10 place-items-center rounded-full bg-white/90 text-slate-600 hover:bg-slate-100"><X size={20} /></button>
      <div className="grid min-h-[calc(100dvh-var(--pp-header-height,118px))] lg:grid-cols-2">
        <section className="flex items-center justify-center bg-[#005bbb] px-5 pb-8 pt-16 sm:px-10 lg:py-8">
          <LoginForm onSuccess={() => navigate(returnTo, { replace: true })} />
        </section>
        <section className="flex min-w-0 flex-col justify-between bg-white">
          <Link to="/" className="mx-auto my-8 block max-w-[70%]"><img src="/images/logo.png" alt="پارس پایپینگ" className="h-auto w-64 max-w-full" /></Link>
          <video src="/media/site-final-2.mp4" autoPlay muted loop playsInline preload="metadata" className="block aspect-video w-full object-contain" aria-label="پارس پایپینگ" />
        </section>
      </div>
    </main>
  );
}
